import React from 'react'

import LogisticTopMenu from '@components/logistic/LogisticTopMenu'
import CouriersTable from '@components/users/couriers/CouriersTable'


export default function CouriersManagementPage () {
  return (
    <div className='CouriersManagement'>
      <h1 className='u-heading'>Управление курьерами</h1>
      <LogisticTopMenu />

      <CouriersTable />
    </div>
  )
}